export { default as CoreAccordion } from './accordion';
export type {
  CoreAccordionProps,
  CoreAccordionItemProps,
  CoreAccordionEvent,
} from '../shared/types/accordion.types';
